// Story 17-2 — aviso de uso que exige la licencia de Evolution GO (condición
// 1.b: visible para los administradores). Solo texto: el logo y la marca se
// rigen por su política de marcas (TRADEMARKS.md del proyecto).

export const EVOLUTION_GO_PROJECT_URL = 'https://github.com/evolution-foundation/evolution-go';

export function EvolutionGoNotice(): React.ReactElement {
  return (
    <p className="text-xs text-muted-foreground">
      La mensajería por este proveedor usa{' '}
      <a
        href={EVOLUTION_GO_PROJECT_URL}
        target="_blank"
        rel="noreferrer"
        className="underline underline-offset-2 hover:text-foreground"
      >
        Evolution GO
      </a>
      , de Evolution Foundation.
    </p>
  );
}
